export interface SelectModel {
  headings: SelectHeading[];
  active: boolean;
  animating: boolean;
}

export interface SelectHeading {
  title: string;
  hidden?: boolean;
  selected?: boolean;
}

export interface SelectValue<T> {
  value: T;
  title: string;
  heading?: string;
  selected?: boolean;
  hidden?: boolean;
  animate?: boolean;
  disabled?: boolean;
}

export interface SingleselectOptions {
  maxHeight?: number;
  search?: boolean;
  headings?: boolean;
  modelPropertyName?: string;
  readonly?: boolean;
  modelHeaderName?: string;
  clearInput?: boolean;
}

export interface MultiselectOptions {
  maxHeight?: number;
  pills?: boolean;
  search?: boolean;
  headings?: boolean;
  selectAll?: boolean;
  modelPropertyName?: string;
}
